import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  responseBar: {
    height: '20px',
    borderRadius: '10px',
    marginTop: theme.spacing(0.5),
    transition: 'width 0.5s ease-in-out',
    backgroundColor: theme.palette.grey[300]
  },
  responseContainer: {
    marginBottom: theme.spacing(1.5),
  },
  yesBar: {
    backgroundColor: theme.palette.success.main
  },
  noBar: {
    backgroundColor: theme.palette.error.main
  }
}));

const BinaryVisualization = ({ yes = 0, no = 0, yesPercentage = 0, noPercentage = 0 }) => {
  const classes = useStyles();

  // Debug logging for incoming props
  console.log('[BinaryVisualization] props:', { yes, no, yesPercentage, noPercentage });

  const validYesPercentage = Math.max(0, Math.min(100, yesPercentage));
  const validNoPercentage = Math.max(0, Math.min(100, noPercentage));

  return (
    <Box>
      <Box className={classes.responseContainer}>
        <Typography variant="body2">
          Yes: {yes} ({Math.round(validYesPercentage)}%)
        </Typography>
        <Box 
          className={`${classes.responseBar} ${classes.yesBar}`}
          style={{ 
            width: `${validYesPercentage}%`,
          }} 
        />
      </Box>
      <Box className={classes.responseContainer}>
        <Typography variant="body2">
          No: {no} ({Math.round(validNoPercentage)}%)
        </Typography>
        <Box 
          className={`${classes.responseBar} ${classes.noBar}`}
          style={{ 
            width: `${validNoPercentage}%`,
          }} 
        />
      </Box>
    </Box>
  );
};

BinaryVisualization.propTypes = {
  yes: PropTypes.number,
  no: PropTypes.number,
  yesPercentage: PropTypes.number,
  noPercentage: PropTypes.number,
};

export default BinaryVisualization; 